export enum PermissionName {
  CompanyInformationView = 'Company Information View',
  CompanyInformationUpdate = 'Company Information Update',
  CompanyNotificationsUpdate = 'Company Notifications Update',
  CompanyVerificationUpdate = 'Company Verification Update',
  ConsumerApplication = 'Consumer Application',
  RoleUpdate = 'Role Update',
  UserView = 'User View',
  UserUpdate = 'User Update',
}
